import { render, staticRenderFns } from "./VBudgetForm.vue?vue&type=template&id=1b052244&"
import script from "./VBudgetForm.vue?vue&type=script&lang=js&"
export * from "./VBudgetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports